import { render, staticRenderFns } from "./AddTax.vue?vue&type=template&id=6c6f1106&"
import script from "./AddTax.vue?vue&type=script&lang=js&"
export * from "./AddTax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports